import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { text, themeTokens } from "@octopusdeploy/design-system-tokens";
const style = css({
    font: text.body.regular.large,
    color: themeTokens.color.text.primary,
    margin: 0,
});
export const AnnotationHelpNote = () => (<p className={style}>
        Need help with annotations?{" "}
        <ExternalLink href={"argo-cd-annotations-docs"} size={"large"}>
            Read the docs
        </ExternalLink>
    </p>);
